"use client";

import React from "react";
import { Card } from "./carousel";
import { cardsData } from "./ServiceItems";

// ✅ This exports an ARRAY of <Card /> components:
const carouselItems = cardsData.map((card, index) => (
  <Card key={index} index={index} layout={true} card={card} />
));

export default carouselItems;
